module.exports = __webpack_public_path__ + "static/media/managers_training.439a1615.png";